import { computed } from 'vue'
import { useRoute } from 'vue-router'

import { showTranscription } from '@/helpers/call-transcription-whitelist-helper'

import { usePermissionsStore } from '@/store/permissionsStore'
import { useDisputeCounterStore } from '@/store/call-tracking/dispute/disputeCounterStore'

import { ROUTES } from '@/constants/routes'

export function useRoutingMenu(isMini = computed(() => false)) {
    const route = useRoute()
    const permissionsStore = usePermissionsStore()
    const disputeCounterStore = useDisputeCounterStore()

    const viewTranscriptionPermission = computed(() => permissionsStore.permissions.transcription.view)
    const pendingCounter = computed(() => disputeCounterStore.pendingCounter)

    function checkCurrentLink(parent, subMenu) {
        const { routeName, isFirstLoad } = parent

        if (subMenu) {
            const isActive = subMenu.some((el) => el.routeName === route.meta.reference)

            if (isActive && isFirstLoad) {
                parent.isOpenSub = isActive
                parent.isFirstLoad = false
            }

            return isActive
        }

        return route.meta.reference === routeName
    }

    function menuStyle(menuRoute) {
        const { isOpenSub, subMenu } = menuRoute

        const active = checkCurrentLink(menuRoute, subMenu)

        const classes = ['transition-all cursor-pointer relative']

        classes.push(isMini.value ? 'mx-auto rounded-1.25' : 'mx-2 px-2 rounded-1.25')

        if (!subMenu) {
            classes.push('flex')
        }

        if (isOpenSub && !isMini.value) {
            classes.push('dark:hover:bg-transparent text-gray-370 dark:text-gray-110')
        } else {
            classes.push(
                'hover:bg-menu-purple70 dark:hover:bg-menu-blue770',
                isMini.value ? 'flex items-center justify-center' : '',
                active ? 'bg-purple-50 dark:bg-menu-blue770 text-purple dark:text-purple-140' : 'dark:text-gray-110 text-gray-370 dark:hover:text-white',
            )
        }

        return classes.join(' ')
    }

    function customStyle({ isOpenSub, subMenu }) {
        if (isMini.value) {
            return { width: '36px', height: '36px' }
        }

        if (subMenu) {
            return { height: isOpenSub ? `${42 + (32 * subMenu.length)}px` : '36px' }
        }

        return undefined
    }

    function getPendingCounter(menuRoute) {
        if (menuRoute.routeName === ROUTES.disputes && pendingCounter.value) {
            return pendingCounter.value
        }

        return null
    }

    function showAi(value) {
        return showTranscription() && viewTranscriptionPermission.value && value
    }

    return {
        checkCurrentLink,
        menuStyle,
        customStyle,
        getPendingCounter,
        showAi,
    }
}
